import WasteSelectorTypes from "../WasteSelectorTypes"; // Ajusta la ruta según sea necesario
import getRegularPercentageContainerSVGJS from "./getRegularPercentageContainerSVGJS";
import L from "leaflet";

const createWasteIconJS = (wasteType, percent = null) => {
    const wasteColors = WasteSelectorTypes[wasteType] || {
        fillColor: "#FFE469",
        borderColor: "#D3A204",
        contrastColor: "#F7CA00",
        backgroundColor: "#FFF09F",
    };

    const svgIconHtml = getRegularPercentageContainerSVGJS({
        ...wasteColors,
        percent,
        width: 57.41,
        height: 80.21,
        overflow: percent > 100,
    });

    return L.divIcon({
        className: "custom-div-icon",
        html: svgIconHtml,
        iconSize: [50, 60],
        iconAnchor: [25, 60],
    });
};
export default createWasteIconJS;
